"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ShopListTrigger=void 0;var r;(function(e){e.HomeSearch="home_search",e.Search="search"})(r||(exports.ShopListTrigger=r={}));
//# sourceMappingURL=ShopListTrigger.js.map
